<template>
  <div
    class="nav-category"
    @scroll="handleScroll()"
    :class="{ 'prevent-scroll': showOverlay }"
  >
    <ProductTab
      :categories.sync="categories"
      :selectedTab.sync="selectedTab"
      :showCategoryMenu.sync="isCategoryShow"
    />

    <div class="filter-bar">
      <div class="filter-bar--row">
        <div class="filter-bar-pi-point">
          <img
            :src="piPointImage"
            alt="pi-point"
            class="filter-bar-pi-point__icon"
          />
          <div class="filter-bar-pi-point__amount">{{ piPoints }}</div>
        </div>
        <div class="filter-bar-button">
          <div class="filter-bar-button__sort" @click="toggleSort">
            {{ sorts[selectSort].displayText }}
            <img
              :src="triangleImage"
              alt="triangle-image"
              :class="{ 'show-menu': isSortShow }"
            />
          </div>

          <img
            v-if="areas.length > 1"
            :src="filterImage"
            alt="filter"
            class="filter-bar-button__filter"
            @click="toggleArea"
          />
        </div>
      </div>
    </div>

    <template v-if="ready">
      <div class="category-title">{{ categoryTitle }}</div>
      <TwoColumn v-if="totalCount > 0" :products="products" gaEvent="003" />
      <div v-else class="section-content no-product-section">
        <div class="logo">
          <img src="@/assets/img/noproduct.svg" class="noproduct" />
        </div>
        <div class="title">沒找到合適的商品</div>
        <div class="subtitle">要不要試試別的篩選條件</div>
      </div>
      <SpinnerBottom class="mb-5" v-show="loading && products.length > 0" />
      <AboutBlock />
    </template>
    <Spinner v-else bgc="#f6f6f6" />
    <div
      v-if="showOverlay"
      @click="closeAll"
      @touchmove.prevent
      class="overlay"
    ></div>
    <nav class="nav-sort">
      <v-expand-transition>
        <div v-show="isSortShow" class="filter-container">
          <div class="row-sort">
            <div
              v-for="(sort, key) in sorts"
              :key="key"
              v-ripple
              class="col col-12"
              :class="{ selected: sort.value === selectSort }"
              @click="selectedSort(sort.value)"
            >
              {{ sort.text }}
            </div>
          </div>
        </div>
      </v-expand-transition>

      <v-expand-transition>
        <div v-show="isAreaShow" class="filter-container">
          <div class="row-sort">
            <div
              v-for="(area, key) in areas"
              :key="key"
              v-ripple
              class="col col-12"
              :class="{ selected: area.value === selectArea }"
              @click="selectedArea(area.value)"
            >
              {{ area.name }}
            </div>
          </div>
        </div>
      </v-expand-transition>
    </nav>
  </div>
</template>

<script>
import ProductTab from '@/components/product/ProductTab'
import Spinner from '@/components/shared/Spinner.vue'
import SpinnerBottom from '@/components/shared/SpinnerBottom'
import TwoColumn from '@/components/layout/twoColumn.vue'
import AboutBlock from '@/components/shared/AboutBlock.vue'

const sorts = [
  { text: '推薦', value: 0, displayText: '推薦' },
  { text: '最新', value: 1, displayText: '最新' },
  { text: '銷量', value: 2, displayText: '銷量' },
  { text: '折數', value: 3, displayText: '折數' },
  { text: '價格從低到高', value: 5, displayText: '價格' },
  { text: '價格從高到低', value: 4, displayText: '價格' },
]
export default {
  name: 'CategoryPage',
  components: {
    Spinner,
    SpinnerBottom,
    ProductTab,
    TwoColumn,
    AboutBlock,
  },
  data: function() {
    return {
      categoryTitle: '',
      categories: [],
      sorts,
      areas: [{ name: '全部地區', value: 0 }],
      selectedTab: 0,
      selectCategory: 0,
      selectArea: 0,
      selectSort: process.env.VUE_APP_DEFAULT_SORT,
      isLocationShow: false,
      isAreaShow: false,
      isSortShow: false,
      isCategoryShow: false,
      products: [],
      inTheEnd: false,
      loading: true,
      ready: false,
      totalCount: 0,
      channelId: null,
      startIndex: 0,
      scrollLock: false,
      coffeeCategory: 111111111,
      filterImage: require('@/assets/img/icon/filter.svg'),
      triangleImage: require('@/assets/img/triangle-down.svg'),
      piPointImage: require('@/assets/img/icon/pi-point.svg'),
      piPoints: '讀取中',
      showOverlay: false,
    }
  },
  watch: {
    selectedTab(newVal, oldVal) {
      this.selectedCategory(newVal)
      this.closeAll()
    },
    isCategoryShow(newVal) {
      if (newVal) {
        this.isAreaShow = false
        this.isSortShow = false
        this.showOverlay = true
      } else {
        this.showOverlay = false
      }
    },
  },
  methods: {
    closeAll(e) {
      this.isAreaShow = false
      this.isSortShow = false
      this.isCategoryShow = false
      this.showOverlay = false
    },
    selectedCategory(value) {
      this.selectCategory = this.categories[value].value
      this.ready = false
      this.getProducts('cat', true)
    },
    selectedArea(value) {
      if (value !== this.selectArea) {
        this.selectArea = value
        this.getProducts('area', true)
      }
      this.isAreaShow = false
      this.showOverlay = false
    },
    selectedSort(value) {
      if (value !== this.selectSort) {
        this.selectSort = value
        this.getProducts('sort', true)
      }
      this.isSortShow = false
      this.showOverlay = false
    },
    handleScroll() {
      if (this.loading) {
        return
      }
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      const windowHeight = window.screen.height
      const scrollBottom = scrollTop + windowHeight
      if (scrollBottom >= scrollHeight - 100 && this.inTheEnd == false) {
        this.getProducts('', false)
      }
    },
    getProducts(whichSelected, reset) {
      this.loading = true
      if (reset) {
        this.products = []
        window.scrollTo({
          top: 0,
        })
      }
      this.startIndex = this.products.length
      if (this.channelId == this.coffeeCategory) {
        api
          .getDealsByCoffee(
            this.channelId,
            this.selectCategory,
            this.selectArea,
            this.selectSort,
            this.startIndex
          )
          .then(res => {
            res.data.dealList.forEach(pd => {
              this.products.push(pd)
            })
            this.totalCount = res.data.totalCount
            // is delivery
            if (res.data.isDelivery) {
              this.isLocationShow = false
              this.selectArea = 0
            } else {
              this.isLocationShow = true
            }
            this.loading = false
            this.ready = true
            this.inTheEnd =
              res.data.inTheEnd || this.startIndex + 10 >= this.totalCount
          })
          .catch(err => {
            this.loading = false
            this.ready = true
            console.log('getProducts Error: ', err)
          })
      } else {
        api
          .getDealsByCategory(
            this.channelId,
            this.selectCategory,
            this.selectArea,
            this.selectSort,
            this.startIndex
          )
          .then(res => {
            this.categoryTitle = res.title
            res.data.dealList.forEach(pd => {
              this.products.push(pd)
            })
            // console.log(this.products.length);
            this.totalCount = res.data.totalCount
            // is delivery
            if (res.data.isDelivery) {
              this.isLocationShow = false
              this.selectArea = 0
            } else {
              this.isLocationShow = true
            }
            this.loading = false
            this.ready = true
            this.inTheEnd =
              res.data.inTheEnd || this.startIndex + 10 >= this.totalCount
          })
          .catch(err => {
            this.loading = false
            this.ready = true
            console.log('getProducts Error: ', err)
          })
      }
    },
    getFilter(list, cat) {
      const index = list.findIndex(item => {
        return item.value === cat.categoryId
      })
      if (index === -1) {
        list.push({
          name: cat.categoryName,
          value: Number(cat.categoryId),
        })
      }
    },
    toggleSort() {
      this.isAreaShow = false
      this.isSortShow = !this.isSortShow
      this.showOverlay = this.isSortShow
    },
    toggleArea() {
      this.isSortShow = false
      this.isAreaShow = !this.isAreaShow
      this.showOverlay = this.isAreaShow
    },
    pollingPipoint() {
      let checkTime = 3
      const timer = setInterval(() => {
        checkTime--
        if (localStorage.getItem('PI_POINTS')) {
          this.piPoints = localStorage.getItem('PI_POINTS')
          clearInterval(timer)
        } else if (!checkTime) {
          this.piPoints = '取得失敗'
          clearInterval(timer)
        }
      }, 1500)
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.channelId = parseInt(this.$route.params.id)
    const piInfo = localStorage.getItem('PI_POINTS')
    if (piInfo != null) this.piPoints = piInfo
    else this.pollingPipoint()
    api
      .getChannelCategories()
      .then(res => {
        const categoryList = res.data.categoryList
        categoryList.forEach(cat => {
          if (cat.channelCategoryId === this.channelId) {
            // 全部地區
            if (cat.categoryType === 5) {
              this.getFilter(this.areas, cat)
            }
            // 全部類別
            if (cat.categoryType === 6) {
              this.getFilter(this.categories, cat)
            }
          }
        })
      })
      .catch(err => {
        console.log('getChannelCaregories Error: ', err)
      })
    this.getProducts('cat', true)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
.prevent-scroll {
  height: 5vh;
  overflow-y: visible;
}

.nav-category {
  // background-color: #f1f2f2;
  padding-top: 100px;
}

.events {
  position: fixed;
  right: 0;
  bottom: 90px;
}

.nav-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-size: 15px;
  white-space: nowrap;
  margin: 0 20px;

  .btn {
    flex: 1 1 33%;
    padding: 12px 0;
    outline: none;
    font-size: 15px;
    color: #222222;
    display: flex;
    align-items: center;
    margin: 0;
    &:nth-child(1) {
      justify-content: flex-start;
    }
    &:nth-child(2) {
      justify-content: center;
    }
    &:nth-child(3) {
      justify-content: flex-end;
    }
    img {
      margin-right: 8px;
    }
  }
}
.filter-container > {
  transition: all 0.2s ease;
  .row {
    padding: 0 10px;
    max-height: 384px;
    overflow-y: scroll;
    z-index: 999;
  }
  .row-sort {
    max-height: 282px;
    overflow-y: scroll;
    z-index: 999;
  }
}
.filter-container .col {
  padding-left: 16px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #545454;
  box-shadow: inset 0 -1px 0 0 #ededed;
  &.selected {
    color: #1da7fc;
  }
}
.filter-container .col img {
  float: right;
}

.nav-sort {
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 112;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.46;
  background-color: rgb(33, 33, 33);
  width: 100%;
  height: 100vh;
  z-index: 111;
}
.category-title {
  font-size: 18px;
  font-weight: bold;
  color: #383838;
  padding: 20px 4.8% 10px;
}

.section-content {
  display: flex;
  padding: 16px 4.8%;
  flex-flow: row wrap;
  background-color: white;
  min-height: calc(100vh - 288px);
  > .item {
    flex: 1 1 calc(50% - 9px);
    margin: 0 4.5px 10px 4.5px;
    flex-grow: 0;
  }
}

.no-product-section {
  display: block;
  justify-content: center;
  padding-top: 40%;
  padding-bottom: 60%;
  .logo {
    text-align: center;
    display: block;
  }
  .title {
    font-family: PingFangTC;
    font-weight: bold;
    font-size: 18px;
    color: #9b9b9b;
    display: block;
    text-align: center;
    font-size: 1.5em !important;
    line-height: 2em;
  }
  .subtitle {
    font-family: PingFangTC;
    font-weight: normal;
    font-size: 14px;
    color: #9b9b9b;
    display: block;
    text-align: center;
    font-size: 1em !important;
    line-height: 1.2em;
  }
  .noproduct {
    width: 72px;
    height: 72px;
    object-fit: contain;
  }
}

.bg-gray {
  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.filter-bar {
  margin-bottom: 1px;
  padding: 10px 18px;
  height: 50px;
  background: white;
  z-index: 12;
  position: fixed;
  width: 100%;
  top: 50px;
  border-bottom: solid 0.5px #ddd;

  &--row {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-pi-point {
    height: 30px;
    padding: 5px 10px;
    border-radius: 24px;
    border: solid 1px #bbbbbb;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1da7fc;
    display: flex;
    align-items: center;

    &__icon {
      width: 16px;
      height: 18px;
    }

    &__amount {
      margin-left: 4px;
    }
  }

  &-button {
    display: flex;
    align-items: center;

    &__sort {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.44px;
      text-align: right;
      color: #383838;
      vertical-align: middle;
      display: flex;
      img {
        margin-left: 5px;
        transition: 300ms;

        &.show-menu {
          transform: rotate(180deg);
          transition: 300ms;
        }
      }
    }
    &__filter {
      margin-left: 18px;
    }
  }
}
</style>
